import type { RouteRecordRaw } from 'vue-router';

import { lazyPage, SeoRobots, type SeoDescriptor } from '@/shared/lib';
import { RouterPages, RouterPaths } from '@/shared/router';

const privacyRoutes: RouteRecordRaw[] = [
  {
    component: lazyPage(() => import('@/pages/privacy'), 'PrivacyPolicyPage'),
    meta: {
      ignoreAuth: true,
      seo: {
        title: { key: 'seo.privacy.title' },
        description: { key: 'seo.privacy.description' },
        robots: SeoRobots.NOINDEX_NOFOLLOW,
      } satisfies SeoDescriptor,
    },
    name: RouterPages.PRIVACY,
    path: RouterPaths.PRIVACY,
  },
] as const;

export { privacyRoutes };
